<template>
  <div class="b-accordion-booking-aside" :class="{ 'is-active': isActive }">
    <div class="b-accordion-booking-aside__header h3" @click="onClickHeader">
      <span>{{ dictionary.asideHeaderTitle }}</span>
      <i class="icon-arrow-dropdown-down"></i>
    </div>
    <div v-if="isActive" class="b-accordion-booking-aside__body">
      <slot></slot>
    </div>
  </div>

  <div
    v-if="!isActive"
    class="b-vehicle-preview d-print-none"
    @click="onClickHeader">
    <div class="b-vehicle-preview__content">
      <div class="b-vehicle-preview__body">
        <div class="b-vehicle-preview__aside">
          <LazyImage v-if="image" :image="image" />
        </div>

        <div class="b-vehicle-preview__main">
          <div class="b-vehicle-preview__title h4 extrabold">
            {{ carObj?.manufacturer }} {{ carObj?.short_model_name }}
          </div>
          <div class="b-vehicle-preview__groups mb-10 semibold">
            <ul>
              <li>{{ modelNameComputed }}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="b-vehicle-preview__footer b-vehicle-preview__footer--wrapped">
        <span class="bold">{{ dictionary.monthlyRentalLabel }}</span>
        <span class="price">€{{ rentalPriceFormatted }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import LazyImage from './../../components/common/LazyImage.vue'
import * as lib from './../../../lib/lib'
import mixinsLeaseItNow from './../../mixins/leaseitnow-mixins'

export default {
  components: { LazyImage },
  mixins: [mixinsLeaseItNow],
  props: {
    carObj: {
      required: true,
      type: Object,
    },
  },
  data() {
    return { isActive: false }
  },
  computed: {
    modelNameComputed() {
      if (!this.carObj) {
        return null
      }
      /* eslint-disable camelcase */
      const { model_name, short_model_name } = this.carObj
      const modelName = model_name.replace(short_model_name, '')

      return `${modelName} ${this.carObj.model_key}`
    },

    rentalPriceFormatted() {
      return this.rentalPrice ? Math.round(this.rentalPrice) : null
    },

    image() {
      const images = this.carObj.slider_images
      if (!images.length) {
        return null
      }
      return {
        url: images[0],
        alt: '',
      }
    },
  },

  methods: {
    onClickHeader() {
      this.isActive = !this.isActive

      this.$nextTick(() => {
        lib.iniTooltips(document)
      })
    },
  },
}
</script>
